<template>
<div class="chapter">
<div class="inner_page">
<h2 class="copyrightText" style="font-size:large;">THE BIG SCREEN</h2>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p class="centerImage"><img alt="image" class="epubimage" height="194" src="11.jpg" width="433"/></p>
<p class="caption" style="text-indent:0%;"><span class="bold">Eadweard Muybridge, splash!, a sequence from 1887</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466827714_fm.vue?4e0cc6ce